import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

export interface PaperUploadData {
  userRequestId: string;
  paperDetail: {
    title: string;
    authors: string;
    doi?: string;
  };
  file: File;
}

export interface PaperUploadResponse {
  success: boolean;
  message: string;
  data: {
    paperRequest: any;
    fileUrl: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class PaperRequestService {
  private readonly baseUrl = `${environment.apiUrl}/user/paperRequest`;

  constructor(private http: HttpClient) {}

  /**
   * Fulfill a user request by uploading a document
   * @param uploadData - Upload data including file and paper details
   * @returns Observable of upload response
   */
  fulfillUserRequest(uploadData: PaperUploadData): Observable<PaperUploadResponse> {
    const formData = new FormData();
    formData.append('userRequestId', uploadData.userRequestId);
    formData.append('paperDetail', JSON.stringify(uploadData.paperDetail));
    formData.append('file', uploadData.file);

    return this.http.post<PaperUploadResponse>(`${this.baseUrl}/fulfillUserRequest`, formData);
  }

  /**
   * Reject a paper request
   * @param requestId - Request ID to reject
   * @returns Observable of rejection response
   */
  rejectRequest(requestId: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/rejectRequest`, { requestId });
  }
} 